import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { AppointmentService } from 'shared/services/appointment/appointment.service';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'cgi-search',
	templateUrl: './cgi-search.component.html',
	styleUrls: ['./cgi-search.component.scss'],
	providers: [AppointmentService],
})
export class CGISearch implements OnInit {
	selectList: any[];
	query = '';
	showOptions = false;
	icdOptions = [];
	@Input() disabled = false;
	@Input() value: any[];

	@Output() onSelect = new EventEmitter<any>();
	@Output() onRemove = new EventEmitter<any>();

	constructor(
		private elementRef: ElementRef,
		private promptuaryService: PromptuaryService
	) {}

	ngOnInit(): void {}

	@HostListener('document:click', ['$event'])
	DocumentClick(event: Event) {
		if (!this.elementRef.nativeElement.contains(event.target))
			this.showOptions = false;
	}

	getCGIOptions(query) {
		this.promptuaryService.getIcdOptions(query).subscribe((options) => {
			this.icdOptions = options;
		});
	}

	searchByQuery() {
		if (this.query.length > 1) {
			this.getCGIOptions(this.query);

			this.showOptions = true;
		}
	}

	select(option) {
		this.onSelect.emit(option);
		this.query = '';
	}

	remove(option) {
		if (this.disabled) {
			return;
		}
		this.onRemove.emit(option.id);
	}
}
